import { render, staticRenderFns } from "./GoodsOrder.vue?vue&type=template&id=87d2fd2c&scoped=true&"
import script from "./GoodsOrder.vue?vue&type=script&lang=js&"
export * from "./GoodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./GoodsOrder.vue?vue&type=style&index=0&id=87d2fd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d2fd2c",
  null
  
)

export default component.exports